import { SvgIcon, type SvgIconProps } from "@mui/material";

interface ShieldProps extends SvgIconProps {
  variant?: "regular" | "bold";
}

export function Shield({ variant = "regular", ...props }: ShieldProps) {
  const path =
    variant === "bold"
      ? "M21 5L12 1L3 5V11C3 16.5 6.8 21.7 12 23C17.2 21.7 21 16.5 21 11V5ZM14 7.1L12 5.5L10 7.1L11 13H9V15H11V18H13V15H15V13H13L14 7.1Z"
      : "M12 1L21 5V11C21 16.5 17.2 21.7 12 23C6.8 21.7 3 16.5 3 11V5L12 1ZM12 3.2L5 6.3V11.2C5 15.5 8.2 20 12 21C15.8 20 19 15.5 19 11.2V6.3L12 3.2ZM12 5.5L14 7.1L13 13H15V15H13V18H11V15H9V13H11L10 7.1L12 5.5Z";

  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
      sx={{
        color: "white",
        fontSize: "24px",
        ...props.sx,
      }}
    >
      <path d={path} fillRule={variant === "bold" ? "evenodd" : undefined} />
    </SvgIcon>
  );
}
